import {
  GET_CITY,
  GET_CITY_SUCCESS,
  GET_CITY_FAILURE,
} from 'store/getCity/getCityAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getCityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CITY:
      return { ...state, loading: true };
    case GET_CITY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_CITY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getCityReducer;
